<template lang="pug">
  div.confirm-layout
    div.alert.alert-success
      span 原退回空瓶數量: {{ Math.abs(currentEvent.number1 )}}

    //- ConfirmStorage(
    //-   v-if="currentProgress === 'setStorage'"
    //-   :inputLabel="'設定空瓶交換數量'"
    //-   :defaultAmount="Math.abs(currentEvent.number1)"
    //-   v-on:setNum="getStorage"
    //- )
    ActionWrap(
      v-if="currentProgress === 'action'"
      :actionProgress="actionProgress"
      v-on:setActionData="getActionData"
      :amountPayload="amountPayload"
    )


</template>

<script>
import ConfirmStorage from '../flowComp/NumberSet';
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';
import ActionWrap from './ActionWrap';

export default {
  name: 'confirmFlow',
  extends: ConfirmFlowBase,
  components: {
    ConfirmStorage,
    ActionWrap,
  },
  data() {
    return {
      amountPayload: {
        emptyCount: 0,
      },
    };
  },
  mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
    this.amountPayload.emptyCount = Math.abs(this.currentEvent.number1); // recycle all amount in the event.
  },
  methods: {
    getStorage(num) {
      this.amountPayload.emptyCount = num;
      if (num > Math.abs(this.currentEvent.number1)) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '回收空瓶數量不可大於該次退回空瓶數量',
        });
      } else {
        this.nextProgress();
      }
    },
    getActionData(val) {
      this.resetProgress();
      this.$emit('confirmationFinish');
    },
  },
};
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// ConfirmFlow.vue?3f59083c